/* 🤖 this file was generated by svg-to-ts */
export const matIconMusicVideo: {
  name: 'music-video';
  data: string;
} = {
  name: 'music-video',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM8 15c0-1.66 1.34-3 3-3 .35 0 .69.07 1 .18V6h5v2h-3v7.03A3.003 3.003 0 0 1 11 18c-1.66 0-3-1.34-3-3z"/></svg>`
};
